/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoicePay } from '../../axios/invoicePay'
import type { InvoicePayError, InvoicePayPathParams, InvoicePayResponse } from '../../types/InvoicePay'

export const invoicePayMutationKey = () => [{ url: '/:organisation/invoices/:invoice/pay' }] as const

export type InvoicePayMutationKey = ReturnType<typeof invoicePayMutationKey>

export type InvoicePayVariables = {
	organisation: InvoicePayPathParams['organisation']
	invoice: InvoicePayPathParams['invoice']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::pay */
export function useInvoicePay<TContext = unknown>(
	options?: UseMutationOptions<InvoicePayResponse, AxiosError<InvoicePayError>, InvoicePayVariables, TContext>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: invoicePayMutationKey(),
		mutationFn: ({ organisation, invoice }: InvoicePayVariables) =>
			invoicePay(organisation, invoice, config).then(res => res.data),
		...options,
	})
}
